export const escapeRegexCharacters = str =>
  str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const createStringMatcher = query => {
  const escQuery = escapeRegexCharacters(query);
  const regex = new RegExp(`\\b${escQuery}`, 'i');
  return name => regex.test(name);
};
